<script>
  import { TopBar } from '@/components/_shared'
  import {
    DashboardFeatured,
    DashboardMyApps,
    DashboardNotification,
    DashboardScreenManager,
    DashboardSupport
  } from '@/components/dashboard'

  export default {
    name: 'dashboard-view',

    components: {
      TopBar,
      DashboardFeatured,
      DashboardMyApps,
      DashboardNotification,
      DashboardScreenManager,
      DashboardSupport
    },

    metaInfo: {
      title: 'Dashboard'
    },

    methods: {
      onHelp () {
        console.log('Handle page help')
      }
    },

    data () {
      return {
        help: this.onHelp
      }
    }
  }
</script>

<template>
  <div class="mb-5">
    <top-bar v-bind="{ help }"/>
    <b-container fluid>
      <dashboard-featured
        backgroundImg="/img/dashboard/featured.png"
        appName="ESPN"
        description="ESPN provides up-to-the-minute sports news coverage, scores, highlights, and commentary for NFL, MLB, NBA, College Football, NCAA Basketball and more."
      />
      <dashboard-notification/>

      <b-row>
        <b-col sm="6">
          <dashboard-screen-manager/>
        </b-col>
        <b-col sm="6">
          <dashboard-my-apps/>
          <dashboard-support/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
